<template>
  <div class="content">
    <p>分子筛式制氧机是指以变压吸附(PSA) 技术为基础，从空气中提取氧气的新设备。其利用分子筛物理吸附和解吸技术在制氧机内装填分子筛，在加压时可将空气中氮气吸附，剩余的未被吸收的氧气被收集起来，经过净化处理后即成为高纯度的氧气。具体工作过程为压缩空气经空气纯化干燥机净化后，通过切换阀进入吸附塔。在吸附塔内，氮气被分子筛吸附，氧气在吸附塔顶部被聚积后进入氧气储罐，再经除异味、除尘过滤器和除菌过滤器过滤即获得合格的医用氧气。</p>
    <p>分子筛是一种晶状铝硅酸盐，其原子按一定的形状排列，基本结构单元是四个</p>
    <p>氧阴离子围绕一个较小的硅或铝离子而形成的四面体。钠离子或其它阳离子的作用是补充铝氧四面体正电荷的不足。四个氧阴离子的每一个，又都分被另一个铝氧或硅氧四面体共用，使晶格作三维延伸。晶格中暴露的阳离子使分子筛具有更强的吸附能力，这些阳离子起着局部强正电荷格点的作用，对极性分子的阴端进行静电吸引，分子的偶极矩越大，被吸引和吸附得越牢。在阳离子上的局部强正电荷的影响下，分子会受到电磁感应而产生偶矩。氧和氮都具有四极矩,但氮的四极矩（0.3ã）比氧（0.1ã）比大得多。因此，氮原子与阳离子之间的作用力较强，而被优先吸附。当有压力时，分子筛会吸附较多的氮原子；当减压时，分子筛会将吸附的氮原子释放出来（称为解吸）。</p>
    <div class="imgbox">
      <img src="../../assets/images/airsep/project1.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabOxygenConcentratorWorkingPrinciple'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  p{
    line-height: 36px;
    text-indent: 40px;
  }
  .imgbox{
    margin: 20px 0px;
  }
}
</style>
